export default "__VITE_ASSET__rMLIQ7h4__"